import React, { useState, useEffect } from 'react'

const TagInput = ({ formik, field, placeholder, className }) => {
    const [localValue, setLocalValue] = useState('');
    const currentValues = formik.values[field];

    // Synchronize localValue with formik values on component mount or when formik values change
    useEffect(() => {
        setLocalValue((currentValues || []).join('\n'));
    }, []);
    
    const handleChange = (e) => {
        const text = e.target.value;
        setLocalValue(text);
        
        const tags = text.split('\n')
            .filter(tag => tag !== '');
        
        formik.setFieldValue(field, tags);
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            
            const cursorPosition = e.target.selectionStart;
            
            // Insert newline at cursor position
            const newText = 
                localValue.substring(0, cursorPosition) + 
                '\n' + 
                localValue.substring(cursorPosition);
            
            setLocalValue(newText);
            
            // Update formik values
            const newTags = newText.split('\n')
                .filter(tag => tag !== '');
            
            formik.setFieldValue(field, newTags);
            
            // Need to defer the cursor positioning to after React updates the DOM
            setTimeout(() => {
                if (e.target) {
                    e.target.selectionStart = cursorPosition + 1;
                    e.target.selectionEnd = cursorPosition + 1;
                }
            }, 0);
        }
    }

    return (
        <div className={`${className}`}>
            <textarea
                className="w-full min-h-32 resize-y textarea textarea-sm textarea-bordered border-solid rounded-md p-2 focus:border-primary focus:ring-1 focus:ring-primary"
                id={field}
                name={field}
                value={localValue}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder={placeholder}
            />
            {formik.errors[field] && formik.touched[field] && 
                <div className='text-red-400 text-sm mt-1'>{formik.errors[field]}</div>
            }
            <div className="text-xs text-gray-500 mt-1">Séparez les réactifs par un retour à la ligne (touche Entrée)</div>
        </div>
    )
}

export default TagInput
